// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__wTALj","right":"Footer_right__SmKyn","buttons":"Footer_buttons__2_vSc"};